/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2018, Zumper
 * @description getMessageOriginString
 */

import { APP_HOSTNAME, localStorageSingleton } from '@zcode/nr-utils'
import { getOptimizelyExperimentsOrigin } from '../../../utils/origin'

interface Props {
  isMobile?: boolean
  multiListingId?: number | `-${number}` | false
  oneTap?: boolean
  origin?: string
  variationMap?: { [title: string]: string | null | undefined }
}

const getMessageOriginString = ({
  isMobile = true,
  multiListingId,
  origin = 'web',
  oneTap,
  variationMap,
}: Props = {}) => {
  let formattedOrigin = origin
  if (isMobile && formattedOrigin.substring(0, 2) !== 'm.') {
    formattedOrigin = `m.${formattedOrigin}`
  }
  if (multiListingId) {
    formattedOrigin = `${formattedOrigin}-mm${multiListingId}`
  }
  if (oneTap) {
    formattedOrigin = `${formattedOrigin}-one_tap`
  }
  try {
    const originArr = [
      formattedOrigin,
      localStorageSingleton.getx('_campaign'),
      localStorageSingleton.getx('_referrer'),
      localStorageSingleton.getx('_traffic'),
    ].map((segment: unknown) => (segment ? String(segment).replace(/,/g, '|') : segment))
    const nameValuePairs: string[] = []
    const experimentOrigin = getOptimizelyExperimentsOrigin(variationMap)
    if (experimentOrigin) {
      nameValuePairs.push(experimentOrigin)
    }
    nameValuePairs.push(`HOST=${APP_HOSTNAME}`)
    if (nameValuePairs.length) {
      originArr.push(nameValuePairs.join('&'))
    }
    return originArr.join(',')
  } catch (err) {
    return formattedOrigin
  }
}

export default getMessageOriginString
